import { db, fetchUserData, fetchQuizzesData } from "../lib/firebase";
import { useState, useRef, useEffect } from "react";
import { ErrorBox } from "./quiz";
import translations from "../translations";
import Button from "../components/button";
import { analytics, logEvent } from "../lib/firebase";
import loadingLogo from "../assets/loading_logo.png"
import { AnimatePresence, motion, useAnimationFrame, useMotionValue } from "framer-motion";


export default function Leaderboard() {

    const queryParameters = new URLSearchParams(window.location.search);
    const code = queryParameters.get("code");

    const [lang, setLang] = useState(queryParameters.get("lang") ?? "en")

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);

    const [quizzes, setQuizzes] = useState([]);

    const [gameMode, setGameMode] = useState(queryParameters.get("mode") ?? "friend")

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let storeLink = "https://apps.apple.com/us/app/bondz-friends-ranking/id6748461951"; // fallback link
  
    if (/android/i.test(userAgent)) {
      storeLink = "https://play.google.com/store/apps/details?id=de.davidschreiber.bondz";
    } else {
      storeLink = "https://apps.apple.com/us/app/bondz-friends-ranking/id6748461951";
    }

    function decode(code) {
        if (code == null) { return "" }
        const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
        let result = 0;
        for (const char of code.toUpperCase()) {
          const index = alphabet.indexOf(char);
          if (index === -1) {
            return null;
          }
          result = result * 26 + index;
        }
        return result.toString().padStart(9, "0");
      }

      async function fetchQuizzes() {
        const uid = decode(code)
        fetchQuizzesData(uid)
        .then((data) => {
            setQuizzes(data);
            setLoading(false);
            setFetching(false);
        })
        .catch((err) => {
            setLoading(false);
            setFetching(false);
        });
      }

    async function fetchUser() {
        const uid = decode(code)
        fetchUserData(uid)
        .then((data) => {
          if (data.state == 0) {
            setUser(data);
            fetchQuizzes();
          } else {
            setLoading(false);
            setFetching(false);
          }
        })
        .catch((err) => {
            setLoading(false);
            setFetching(false);
        });
      }

      useEffect(() => {
        document.title = "BondZ Ranking";
        if (code != null && user == null && !fetching && code != null) {
            fetchUser()
        } else {
            setLoading(false)
        }
    }, []);

    return (
        <motion.div className="qzwrppro"
        
          transition={{ duration: 2.0, ease: "easeOut" }}
        >
            
        </motion.div>
    )
}